import { Factory } from '../../../lib/api';
const activatePolygon = (polygonId) => Factory.post(`api/v2/polygons/${polygonId}/activate`);
export default activatePolygon;
